<template lang="pug">
v-container(fluid)
  div(class="d-flex justify-space-between mb-2")
    h2(class="blue-grey--text")
      v-icon(class="mr-1") mdi-ticket-account
      span 活動帳務管理
  SearchForm(
    :addMode="addMode"
    @add="handleAdd"
    @search="handleSearch"
  )
  v-divider(class="my-4")
  SearchTable(
    :loading="loading"
    :dataList="listData"
    :addMode="addMode"
    @update="handleUpdate"
    @addItem="handleAddItem"
    @cancelAddItem="handleCancelAddItem"
    @delete="handleDeleteItem"
  )
</template>

<script>
import SearchForm from "@/components/serialNumber/searchForm";
import SearchTable from "@/components/serialNumber/searchTable";
export default {
  name: "serialNumberSearch",
  components: {
    SearchForm,
    SearchTable,
  },
  data: () => ({
    analyzeData: {},
    group: [],
    listData: [],
    loading: false,
    addMode: false,
  }),
  methods: {
    async getClcList() {
      try {
        let clcListRes = await this.$api.common.commonAPI.getClcList();
        if (clcListRes && clcListRes.data.code === 200) {
          this.$store.dispatch("group/setClcList", clcListRes.data.content);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getList(payload) {
      try {
        this.loading = true;
        let listRes = await this.$api.serialNumber.serialNumberAPI.getList(
          payload
        );
        if (listRes && listRes.data.code === 200) {
          this.listData = listRes.data.content;
        }
        if (!listRes.data.success && listRes.data.showalert) {
          this.$store.dispatch("notification/openNotification", {
            msg: listRes.data.message,
            color: "red",
            timeout: 5000,
            showClose: false,
          });
          if (listRes.data.isRedirect) {
            this.$router.push("/permissions");
          }
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
      }
    },
    handleSearch(searchPayload) {
      this.getList(searchPayload);
    },
    async handleUpdate(item) {
      try {
        await this.$api.serialNumber.serialNumberAPI.modifySerialNumber(item);
        this.$store.dispatch("notification/openNotification", {
          msg: `資料已更新`,
          color: "green",
          timeout: 5000,
          showClose: false,
        });
        this.getList({});
      } catch (err) {
        console.log(err);
      }
    },

    handleAdd() {
      this.listData.unshift({
        parmChurch: null,
        number: null,
        memberId: "",
        groupId: null,
        name: null,
        lastDedicationDate: this.$dayjs().format("YYYY-MM-DD"),
        isExpired: 0,
        statusText: "使用中",
        updateMemberId: "",
        updateMemberText: "",
      });
      this.addMode = true;
    },

    handleCancelAddItem() {
      this.listData = this.listData.filter((item) => {
        return item.id;
      });
      this.addMode = false;
    },

    async handleAddItem(item) {
      try {
        await this.$api.serialNumber.serialNumberAPI.addSerialNumber(item);
        this.$store.dispatch("notification/openNotification", {
          msg: `資料已新增`,
          color: "green",
          timeout: 5000,
          showClose: false,
        });
        this.addMode = false;
        this.getList({});
      } catch (err) {
        console.log(err);
      }
    },

    async handleDeleteItem(item) {
      try {
        await this.$api.serialNumber.serialNumberAPI.deleteSerialNumber({
          id: item.id,
        });
        this.$store.dispatch("notification/openNotification", {
          msg: "已刪除",
          color: "green",
          timeout: 5000,
          showClose: false,
        });
        this.getList({});
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.getClcList();
    this.getList({});
  },
};
</script>
